<template>
  <div
    ref="partialDiv"
    :class="{
      'container mx-auto': true,
    }"
  >
    <div
      :class="{
        'uss-error-out mt-6': true,
      }"
    >
      <div
        :class="{
          'text-center text-xl font-semibold leading-9 text-www-color-neutral-medium-dark md:text-2xl md:leading-[2.6875rem] lg:text-5xl lg:leading-[5.4rem]': true,
        }"
      >
        {{ title }}
      </div>
      <component
        :is="getComponent(subtitle._type)"
        v-if="subtitle?._type"
        :value="subtitle"
        :class="{
          'my-6': true,
        }"
      />
    </div>
    <template v-if="screenPartialData?.sectionBuilder?.length > 0">
      <component
        :is="getComponent(component._type)"
        v-for="component in screenPartialData?.sectionBuilder"
        :key="component._key"
        :value="component"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import { getComponent } from '~/components/Mapper';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type EmailCheck204SignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/EmailCheck204SignupScreen';
import type { SignupPartialViewsSectionBuilder, UssSuccessRedirect } from '~/sanity/types';
import UnifiedSignupStartScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupStartScreen';
import RedirectUtil from '~/hekate-www/external/util/RedirectUtil';
import { setMaskedEmailInElements } from '~/hekate-www/external/util/EmailMaskUtil';

const props = defineProps<
  UssSuccessRedirect & {
    signupScreen: EmailCheck204SignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
    screenPartialData: SignupPartialViewsSectionBuilder;
  }
>();

const partialDiv = ref<HTMLDivElement | null>(null);

// Handle buyStandard redirect
const onCodeEmbedRendered = () => {
  // Mask and display email in elements with hekate-data="email" attribute
  const email = props.signupScreen.getField(FieldHtmlNameUtil.email).val as string;
  setMaskedEmailInElements(partialDiv.value, email);

  if (props.sessionInfo.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard)) {
    partialDiv.value?.classList.add('d-none');
    RedirectUtil.redirectTo({
      delay: 0,
      target: props.signupScreen.getField(FieldHtmlNameUtil.signupRedirectUrl).val as string,
    });
    return;
  }

  // Show/hide geo-blocked vs default message
  let toShow: Element | null = null;
  let toHide: NodeListOf<Element> | null = null;

  if (props.sessionInfo.emailCheckErrorReason === 'geo-blocked') {
    partialDiv.value?.querySelectorAll('.error-box').forEach((elm) => elm.classList.add('d-none'));
    toShow = partialDiv.value?.querySelector('[hekate-data=geo-blocked-msg]') ?? null;
    toHide = partialDiv.value?.querySelectorAll('[hekate-data=default-204]') ?? null;
  } else {
    toShow = partialDiv.value?.querySelector('[hekate-data=default-204]') ?? null;
    toHide = partialDiv.value?.querySelectorAll('[hekate-data=geo-blocked-msg]') ?? null;
  }

  toHide?.forEach((elm) => {
    elm.classList.add('d-none');
  });
  toShow?.classList.remove('d-none');
};

onMounted(() => {
  partialDiv.value?.addEventListener('code-embed-rendered', onCodeEmbedRendered);
});

onUnmounted(() => {
  partialDiv.value?.removeEventListener('code-embed-rendered', onCodeEmbedRendered);
});
</script>

<style></style>
